"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const axios_1 = require("@nestjs/axios");
const environment_1 = require("../../../service-lib/src/lib/environment");
const rxjs_1 = require("rxjs");
let AppService = class AppService {
    constructor(httpService) {
        this.httpService = httpService;
        this.services = [];
        this.registryUrl = `${environment_1.ENV.URL_SERVICE_REGISTRY}/service-registry/registry`;
    }
    getData() {
        return { message: "API Gate way running successfully.." };
    }
    /*
      Commented out the onModuleInit method to avoid loading services at startup
      Using serive-registry to find the services
      Date: 2025-05-21 5:00 PM
    */
    // async onModuleInit() {
    //   await this.loadServices();
    //   console.log("Services loaded:", this.services);
    //   // Refresh services every 30 seconds
    //   setInterval(() => this.loadServices(), 30000);
    // }
    // private async loadServices() {
    //   try {
    //     const response = await firstValueFrom(
    //       this.httpService.get<ServiceInfo[]>(`${this.registryUrl}/services`)
    //     );
    //     this.services = response.data;
    //   } catch (error) {
    //     console.error("Failed to load services from registry:", error);
    //   }
    // }
    async getServiceUrl(serviceName) {
        const response = await (0, rxjs_1.firstValueFrom)(this.httpService.get(`${this.registryUrl}/service/${serviceName}`));
        const service = response.data;
        if (!service) {
            throw new Error(`Service ${serviceName} not found`);
        }
        else if (service.status !== "active") {
            throw new Error(`Service ${serviceName} is down`);
        }
        return service.url;
    }
    async registerService(serviceData) {
        try {
            this.services = [...this.services, serviceData];
        }
        catch (error) {
            throw new common_1.HttpException(error.message || "Service unavailable", error.status || common_1.HttpStatus.BAD_GATEWAY);
        }
    }
};
exports.AppService = AppService;
exports.AppService = AppService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof axios_1.HttpService !== "undefined" && axios_1.HttpService) === "function" ? _a : Object])
], AppService);
